<template>
  <div>
    <el-input
      id="search-patient-container"
      v-model="inputPatientName"
      class="search-patient-input"
      :placeholder="$t('OrderPage[\'Type Patient Name\']')"
      @input="debounceSearchPatient"
      @focus="handleFocus"
      @blur="inputPatientFocus = false"
    >
    <template v-slot:prefix>
      <img src="@/assets/orderTest/search_24px.svg" alt="search icon">
    </template>
    </el-input>
    <div v-show="inputPatientFocus" class="search-box">
      <div v-if="inputPatientName" v-loading="patientSearchLoading" style="min-height: 141px;">
        <PatientContainerSearchPatientNotFound
          v-if="filteredPatientList.length === 0 && !patientSearchLoading" 
          class="text-center pt-11"
          :name="inputPatientName"    
        />
        <PatientContainerSearchPatientList 
          v-else 
          :patient-list="filteredPatientList"
          :input-patient-name="inputPatientName"
          :disabled-patient-id="disabledPatientId"
          @clickSearchedPatient="$emit('clickSearchedPatient', $event)"
          class="overflow-auto"
          style="max-height: 232px"
        />
      </div>
      <div  
        id="create-new-patient"
        class="create-new-patient flex items-center cursor-pointer" 
        @mousedown="createPatient"
      >
        <p>{{ $t("OrderPage[\"Create New Patient\"]") }}</p> 
        <span class="material-icons mx-2.5">person_add_alt_1</span>
        <p class="ont-bold">{{ inputPatientName }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { searchPatientApi } from "@/api/va-order-page/orderTest.js";
import PatientContainerSearchPatientNotFound from "./SearchPatientNotFound.vue";
import PatientContainerSearchPatientList from "./SearchPatientList.vue";

export default {
  emits: ["createPatient", "clickSearchedPatient"],
  components: {
    PatientContainerSearchPatientNotFound,
    PatientContainerSearchPatientList,
  },
  props: {
    disabledPatientId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      inputPatientName: "",
      filteredPatientList: [],
      inputPatientFocus: false,
      patientSearchLoading: false,
      patientFirstName: "",
      patientMiddleName: "",
      patientLastName: "",
    }
  },

  watch: {
    inputPatientName(newVal) {
      this.patientSearchLoading = newVal.length > 1 ? true : false;
    }
  },

  created() {
    this.debounceSearchPatient = _.debounce(this.searchPatient, 500);
  },

  methods: {
    searchPatient() {
      sessionStorage.removeItem('pediatricConsentInfo');
      sessionStorage.removeItem('guardianEmail');
      this.filteredPatientList = [];
      // call searchPatient api when user input at least 2 characters
      if (this.inputPatientName.length > 1) {
        searchPatientApi({ inputPatient: this.inputPatientName })
          .then(res => {
            this.filteredPatientList = res.data?.filter(p => p.isActive) || [];
            this.patientSearchLoading = false;
          })
          .catch(err => {
            this.patientSearchLoading = false;
          });
      }
    },
    createPatient() {
      this.$emit('createPatient', this.inputPatientName)
    },
    handleFocus() {
      this.inputPatientFocus = true;
      // remove error class if any when input is focus
      let patientInputElement = this.$el.getElementsByClassName("el-input__inner")[0];
      patientInputElement.classList.remove("error");
    }
  }
}
</script>

<style scoped>
.search-box {
  background-color: #FFFFFF;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
  overflow: auto;
  color: #767676;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0.4px;
  line-height: 16px;
  position: relative;
  z-index: 3000;
}

.create-new-patient {
  padding: 10px 13.1px;
  border-top: 1px solid #E0E0E0;
  color: #20A7C1;
  font-size: 15px;
  line-height: normal;
  letter-spacing: 0.429px;
}

.create-new-patient:hover {
  background: #F9FBFD;
}
</style>